
promokit.preload({
    complete: function() {
        pageMain.init();
    }
});

const pageMain = (()=>{
    let init = ()=>{
        motions();
        falling();

        $(document).on({
            'mouseenter': function(){
                TweenMax.to( $(this).find('a'), 0.3, { opacity: 1 } );
                TweenMax.fromTo( $(this).find('strong'), 0.3, { y: 30 }, { y: 0, opacity: 1} );
            },
            'mouseleave': function(){
                TweenMax.to( $(this).find('a'), 0.3, { opacity: 0 } );
                TweenMax.to( $(this).find('strong'), 0.3, { opacity: 0 } );
            }
        }, '.link__item')
    };
    const motions = ()=>{
        let tl = new TimelineMax();

        /* 타이틀 */
        tl.fromTo('.p-header__title', 1, { y: 80, opacity: 0 }, { y: 0, opacity: 1, ease: Power2.easeOut, delay: 0.5 });

        /* 서브 타이틀 */
        tl.fromTo('.p-header__sub-title', 1, { y: 80, opacity: 0 }, { y: 0, opacity: 1, ease: Power2.easeOut }, '-=0.75');

        /* 캐릭터 모션 */
        tl.fromTo('.char', 1, { scale: 0, opacity: 0 }, { scale: 1, opacity: 1, ease: Elastic.easeOut.config(1, 0.95) }, '-=0.65');

        /* 링크 모션 */
        tl.fromTo('.link', 1, { y: 80, opacity: 0 }, { y: 0, opacity: 1, ease: Power2.easeOut }, '-=0.35');

        /* 유틸 모션 */
        tl.fromTo('.util', 1, { y: 80, opacity: 0 }, { y: 0, opacity: 1, ease: Power2.easeOut }, '-=0.75');

        /* 푸터 모션 */
        tl.fromTo('.section-footer', 1, { y: 20, opacity: 0 }, { y: 0, opacity: 1, ease: Power2.easeOut }, '-=0.75');

        /* '춘' 모션*/
        tl.fromTo('.p-header__title-2 em', 0.6, { scale: 1.5, rotationX: 180, opacity: 0, transformOrigin: 'center top' }, { scale: 1, rotationX: 0, opacity: 1, ease: Elastic.easeOut.config(1, 0.9) }, '-=0.6');
    };
    const falling = ()=>{
        let flag = true;
        TweenLite.set("#container",{perspective:600});
        TweenLite.set("img",{xPercent:"-50%",yPercent:"-50%"});

        let total = 20;
        let container = document.getElementById("falling"),
            w = window.innerWidth,
            h = window.innerHeight;

        for (i=0; i<total; i++){
            var Div = document.createElement('div');
            TweenLite.set(Div,{attr:{class:'falling__item'},x:R(0,w),y:R(0,h),z:R(0,0)});
            container.appendChild(Div);
            animm(Div);
        };

        function animm(elm){
            TweenMax.to(elm,R(9,15),{x:-w+100,ease:Linear.easeNone,repeat:-1,delay:-15});
            TweenMax.to(elm,R(4,8),{y:'+=100',rotationZ:R(0,180),repeat:-1,yoyo:true,ease:Sine.easeInOut});
            TweenMax.to(elm,R(2,8),{rotationX:R(0,360),rotationY:R(0,360),opacity:R(0.5, 1),repeat:-1,yoyo:true,ease:Sine.easeInOut,delay:-5});
        };
        function R(min,max) {return min+Math.random()*(max-min)};
    };
    return {
        init
    }
})();


// WEBPACK FOOTER //
// ./src/js/index.js